import BaseApi from '../BaseApi';
import { BonusProgramConverter } from './BonusProgramConverter';

class BonusProgramApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new BonusProgramConverter();
  }

  createGift = (data) =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/gift/create`,
      data,
    );

  editGift = (data) => {
    const id = (data?.get && data?.get('id')) ?? data.id;

    return this.sendQuery(
      this.queryTypes.PUT,
      `${this.baseUrl}/gift/update/${id}/`,
      data,
    );
  }

  getCurrentGifts = data =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/gift/list`,
      data,
      null,
      this.converter.convertCurrentGifts,
    );

  deleteGift = ({ id }) =>
    this.sendQuery(
      this.queryTypes.DELETE,
      `${this.baseUrl}/gift/delete/${id}/`,
    );

}


export default BonusProgramApi;
